"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignaturePopup_1 = require("./SignaturePopup");
var test_json_data_1 = require("./test_json_data");
var sweetalert2_1 = __importDefault(require("sweetalert2"));
console.log("Wrapper");
new SignaturePopup_1.SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data_1.test_json_data;
}
var secondary_json_data = {
    slug: process.env.SLUG ? process.env.SLUG : "avedamaine",
    email_template_id: process.env.SLUG,
    acronym: process.env.ACRONYM_SLUG,
    pack_id: "la_application",
    advisor_email: "admissions@avedamaine.edu",
    v2_pdf_upload_code: "ENR",
    form_type: "edularCore",
    version: "v3",
    forms: [
        {
            url: process.env.BASE_DOMAIN + "?form_id=application_admissions",
            title: "Application Admissions"
        },
        {
            url: process.env.BASE_DOMAIN + "?form_id=signature_certificate",
            title: "Signature Certificate"
        }
    ]
};
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        var check, page, textPage, SUBMIT_TEXT, _a, status_1, body, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    console.log("submit");
                    console.log(window.pdf.json_data);
                    return [4, window.pdf.validate()];
                case 1:
                    check = _b.sent();
                    if (!check) {
                        alert("Please check errors");
                        return [2];
                    }
                    document.getElementById("root").style.display = "none";
                    page = document.getElementById("success_page");
                    textPage = document.getElementById("wait_text");
                    SUBMIT_TEXT = "Please wait while we process your information.";
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    textPage.textContent = SUBMIT_TEXT;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, sendRequest(__assign(__assign(__assign({}, window.pdf.json_data), { full_name: window.pdf.json_data.first_name + " " + window.pdf.json_data.middle_name + " " + window.pdf.json_data.last_name }), secondary_json_data), "/v3/submit/standalone")];
                case 3:
                    _a = _b.sent(), status_1 = _a.status, body = _a.body;
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    if (status_1 !== 200) {
                        document.getElementById("root").style.display = "block";
                        sweetalert2_1.default.fire({
                            icon: "warning",
                            title: "Error while submitting the form.",
                            text: "Something happened while submitting your form, please check. " + JSON.stringify(body),
                            width: "500px"
                        });
                        window.pdf.json_data.errors = body === null || body === void 0 ? void 0 : body.errors;
                        window.pdf["model"].dispatcher.dispatch();
                        return [2];
                    }
                    showSuccessPage(body._id, page, textPage);
                    return [3, 5];
                case 4:
                    error_1 = _b.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Server down.",
                        text: "Our servers are down. Please try again later.",
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
function sendRequest(json_data, url) {
    return __awaiter(this, void 0, void 0, function () {
        var rawResponse, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, fetch("" + process.env.API_DOMAIN + url, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(json_data)
                    })];
                case 1:
                    rawResponse = _a.sent();
                    return [4, rawResponse.json()];
                case 2:
                    body = _a.sent();
                    console.log(rawResponse.status);
                    console.log(body);
                    return [2, { status: rawResponse.status, body: body }];
            }
        });
    });
}
function showSuccessPage(id, page, textPage) {
    return __awaiter(this, void 0, void 0, function () {
        var GENERATE_PDF, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    GENERATE_PDF = "Please wait your PDF file is being generated.";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    textPage.textContent = GENERATE_PDF;
                    page.style.display = "flex";
                    page.style.zIndex = "99999";
                    return [4, waitUntilJobComplete(id)];
                case 2:
                    _a.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "success",
                        title: "Request sent",
                        text: "Thank you for submit your application. An advisor will contact you soon.",
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    page.innerHTML = "<strong>Generating PDF files completed.</strong>";
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    page.style.display = "none";
                    page.style.zIndex = "0";
                    sweetalert2_1.default.fire({
                        icon: "error",
                        title: "Error while generating the pdf's.",
                        text: "Something happened while generating the pdf forms, please try again later.",
                        width: "500px"
                    }).then(function () {
                        window.location.assign(process.env.BASE_DOMAIN);
                        location.reload();
                    });
                    page.innerHTML = "<strong>Error Generating PDF files.</strong>";
                    console.log(e_1);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
function waitUntilJobComplete(id) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    var interval_id = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                        var status, body, r, e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4, sendRequest({}, "/check/" + id)];
                                case 1:
                                    r = _a.sent();
                                    status = r.status;
                                    body = r.body;
                                    return [3, 3];
                                case 2:
                                    e_2 = _a.sent();
                                    clearInterval(interval_id);
                                    clearTimeout(timeout_id);
                                    reject(e_2);
                                    return [2];
                                case 3:
                                    console.log(body.jobs);
                                    if (status !== 200) {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        reject("Got status code not 200 from API");
                                    }
                                    if (body.jobs.status === "done") {
                                        clearInterval(interval_id);
                                        clearTimeout(timeout_id);
                                        resolve();
                                    }
                                    return [2];
                            }
                        });
                    }); }, 3000);
                    var timeout_id = setTimeout(function () {
                        clearInterval(interval_id);
                        reject(new Error("1 minute timeout reached"));
                    }, 60 * 1500);
                })];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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